export const listEnsembles = /* GraphQL */ `
    query ListEnsembles(
        $id: ID
        $filter: ModelEnsembleFilterInput
        $limit: Int
        $nextToken: String
        $sortDirection: ModelSortDirection
    ) {
        listEnsembles(
            id: $id
            filter: $filter
            limit: $limit
            nextToken: $nextToken
            sortDirection: $sortDirection
        ) {
            items {
                id
                slug
                name
                code
                state {
                    enabled
                }
                createdAt
                updatedAt
            }
            nextToken
        }
    }
`;


export const updateEnsemble = /* GraphQL */ `
    mutation UpdateEnsemble(
        $input: UpdateEnsembleInput!
        $condition: ModelEnsembleConditionInput
    ) {
        updateEnsemble(input: $input, condition: $condition) {
            id
            slug
            name
            code
            state {
                enabled
            }
            createdAt
            updatedAt
        }
    }
`;

export const onCreateEnsemble = /* GraphQL */ `
    subscription OnCreateEnsemble {
        onCreateEnsemble {
            id
            slug
            name
            code
            state {
                enabled
            }
            createdAt
            updatedAt
        }
    }
`;
export const onUpdateEnsemble = /* GraphQL */ `
    subscription OnUpdateEnsemble {
        onUpdateEnsemble {
            id
            slug
            name
            code
            state {
                enabled
            }
            createdAt
            updatedAt
        }
    }
`;
export const onDeleteEnsemble = /* GraphQL */ `
    subscription OnDeleteEnsemble {
        onDeleteEnsemble {
            id
            slug
            name
            code
            state {
                enabled
            }
            createdAt
            updatedAt
        }
    }
`;

